import { render, staticRenderFns } from "./StockingsFormPage.vue?vue&type=template&id=ecc8350e&"
import script from "./StockingsFormPage.vue?vue&type=script&lang=js&"
export * from "./StockingsFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports